import IconArrowLeft from '@img/icons/icon-slider-arrow-left.svg';
import IconArrowRight from '@img/icons/icon-slider-arrow-right.svg';
import React, { FunctionComponent, ReactNode } from 'react';
import { SliderButtonStyles } from './SliderButton.styles';

export interface SliderButtonProps {
  theme?: 'red' | 'white' | 'black' | 'lightgrey';
  iconTheme?: 'red' | 'white' | 'black';
  previousAriaLabel?: string;
  nextAriaLabel?: string;
  direction: 'left' | 'right';
  onClick?: () => void;
  disabled?: boolean;
}

const SliderButton: FunctionComponent<SliderButtonProps> = ({
  theme = 'red',
  iconTheme = theme === 'white' ? 'black' : 'white',
  onClick,
  direction,
  previousAriaLabel = 'Previous',
  nextAriaLabel = 'Next',
  disabled = false,
}) => {
  const isNext = direction === 'right';
  let ariaLabel = '';

  if (isNext) {
    ariaLabel = nextAriaLabel;
  } else {
    ariaLabel = previousAriaLabel;
  }

  const _onClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    if (disabled || !onClick) {
      event.preventDefault();
      return;
    }

    onClick();
  };

  return (
    <SliderButtonStyles.SliderButtonElement
      disabled={disabled}
      theme={theme}
      iconTheme={iconTheme}
      onClick={_onClick}
      aria-label={ariaLabel}
    >
      {renderIcon(direction)}
    </SliderButtonStyles.SliderButtonElement>
  );
};

function renderIcon(direction: 'left' | 'right'): ReactNode {
  switch (direction) {
    default:
    case 'left': {
      return <IconArrowLeft />;
    }

    case 'right': {
      return <IconArrowRight />;
    }
  }
}

export default SliderButton;
